<div class="cc-del-header">
  <div class="cc-del-icon">
    <mat-icon>delete_forever</mat-icon>
  </div>
  <div>
    <h2 mat-dialog-title class="cc-del-title">Eliminar concepto</h2>
    <p class="cc-del-sub">Esta acción no se puede deshacer</p>
  </div>
  <button mat-icon-button class="cc-del-close" [mat-dialog-close]="null" matTooltip="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="cc-del-content">
  <p *ngIf="!error" class="cc-del-msg">
    ¿Seguro que quieres eliminar este concepto?
  </p>
  <div *ngIf="error" class="cc-del-feedback">
    <mat-icon>{{ message === 'Concepto eliminado' ? 'check_circle' : 'error_outline' }}</mat-icon>
    <span>{{ message }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="cc-del-actions">
  <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
  <button *ngIf="!error" mat-flat-button class="cc-del-btn" (click)="delete()">
    <mat-icon>delete</mat-icon> Eliminar
  </button>
</mat-dialog-actions>
